/***********************************
 * CUSTOM UPSELLS by DERECK SANTOS *
 ***********************************/

document.addEventListener("DOMContentLoaded", () => { 
  const form = document.querySelector("form[data-type='add-to-cart-form']");
  if (!form) return;

  const btn = document.querySelector("#AddToCart");
  if (!btn) return;

  const upsellCheckboxes = form.querySelectorAll(".mm-upsell-checkbox");

  // Remove ALL existing click listeners from the theme button
  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);

  newBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopPropagation(); // Make sure theme JS does not intercept

     // ✅ START loading animation/state
    newBtn.disabled = true;
    newBtn.setAttribute("aria-busy", "true");
    newBtn.classList.add("is-loading", "loading");

    const mainVariant = Number(form.querySelector("input[name='id']")?.value);
    if (!mainVariant) return;

    // Build upsell items with a "parent" property pointing to the main product
    const upsells = [...upsellCheckboxes]
      .filter(cb => cb.checked)
      .map(cb => ({
        id: Number(cb.value),
        quantity: 1,
        properties: { parent: mainVariant } // Battery/upsell is dependent on this variant
      }));

    // First item is the main product, followed by upsells
    const items = [{ id: mainVariant, quantity: 1 }, ...upsells];

    try {
      console.log("MM items going into fetch:", items);

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });

      // Handle Shopify add-to-cart errors (e.g. max quantity, sold out, etc.)
      if (!res.ok) {
        const errorText = await res.text();
        let message = "Unable to add this item.";

        try {
          const errorJson = JSON.parse(errorText);
          if (errorJson.message) message = errorJson.message;
        } catch (e) {
          console.warn("Failed to parse Shopify error JSON");
        }

        alert(message); // Simple UX: show the real Shopify message
        console.error("Add-to-cart error:", message);
        return;
      }

      // Refresh drawer content (items, totals, etc.)
      await refreshCartDrawer();

      // Refresh header cart count (purple bubble in header)
      await refreshCartCount();

      // Open drawer AFTER content & counts have been updated
      setTimeout(() => {
        const drawer = document.querySelector("#Cart-Drawer");
        if (!drawer) return;

        document.body.classList.add("open-cc");
        drawer.classList.add("active");
        drawer.focus();

        if (typeof window.dispatchCustomEvent === "function") {
          window.dispatchCustomEvent("cart-drawer:open");
        }
      }, 150);

    } catch (err) {
      console.error("MM Error adding upsells:", err);
    } finally {
        newBtn.disabled = false;
        newBtn.removeAttribute("aria-busy");
        newBtn.classList.remove("is-loading", "loading");
    }
  });

  /***************************************************
   * MUTATION OBSERVER
   * - Watches the cart drawer for ANY DOM changes
   * - Ensures "parent:" property is always removed
   *   even when theme JS updates quantities, etc.
   ***************************************************/
  const drawer = document.querySelector("#Cart-Drawer");
  if (drawer) {
    const observer = new MutationObserver(() => {
      stripParentProperty();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }
}); // end DOMContentLoaded


/***************************************************
 * GLOBAL REMOVE BUTTON HANDLER (WITH DEPENDENTS)
 * - Bulletproof against line index shifts
 ***************************************************/
document.addEventListener("click", async (e) => {
  const removeBtn = e.target.closest(".remove[data-index]");
  if (!removeBtn) return;

  e.preventDefault();

  const clickedIndex = Number(removeBtn.getAttribute("data-index"));

  // 1. Load cart
  let cart = await fetch("/cart.js").then(r => r.json());
  const clickedItem = cart.items[clickedIndex - 1];
  if (!clickedItem) return;

  const isParent = !clickedItem.properties?.parent;
  const parentVariant = isParent ? clickedItem.variant_id : null;

  // 2. If parent → remove children first
  if (isParent) {
    const childLines = cart.items
      .map((item, i) => ({ item, line: i + 1 }))
      .filter(({ item }) => item.properties?.parent == parentVariant)
      .map(({ line }) => line)
      .sort((a, b) => b - a);

    for (const line of childLines) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: 0 })
      });
    }

    // 3. Re-fetch cart to get fresh indexes
    cart = await fetch("/cart.js").then(r => r.json());

    // 4. Find parent again
    const newParentIndex = cart.items.findIndex(
      item => item.variant_id === parentVariant && !item.properties?.parent
    );

    if (newParentIndex !== -1) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: newParentIndex + 1, quantity: 0 })
      });
    }
  } else {
    // If clicking a child → just remove it
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: clickedIndex, quantity: 0 })
    });
  }

  await refreshCartDrawer();
  await refreshCartCount();
});


/***************************************************
 * REFRESH CART DRAWER CONTENT (ONLY THE CONTENT)
 * - Updates items, totals, free shipping bar, etc.
 * - Fixes Cart count in drawer header
 * - Calls stripParentProperty() to hide parent row
 ***************************************************/
async function refreshCartDrawer() {
  try {
    const cartRes = await fetch("/?sections=cart-drawer");
    const cartJson = await cartRes.json();

    const html = cartJson["cart-drawer"];
    if (!html) return console.warn("Cart drawer HTML missing");

    const temp = document.createElement("div");
    temp.innerHTML = html;

    // 1) content
    const newContent = temp.querySelector(".side-panel-content");
    const content = document.querySelector("#Cart-Drawer .side-panel-content");
    if (newContent && content) content.innerHTML = newContent.innerHTML;

    // 2) header count
    const newHeaderCount = temp.querySelector(".side-panel-header sup");
    const currentHeaderCount = document.querySelector("#Cart-Drawer .side-panel-header sup");
    if (newHeaderCount && currentHeaderCount) currentHeaderCount.textContent = newHeaderCount.textContent;

    // 3) footer (THIS is what you're missing)
    const newFooter = temp.querySelector(".side-panel-footer");
    const footer = document.querySelector("#Cart-Drawer .side-panel-footer");

    if (newFooter) {
      if (footer) {
        footer.innerHTML = newFooter.innerHTML;
      } else {
        const inner = document.querySelector("#Cart-Drawer .side-panel-inner");
        if (inner) inner.appendChild(newFooter);
      }
    } else if (footer) {
      footer.remove(); // cart became empty
    }

    stripParentProperty();
  } catch (err) {
    console.warn("Cart drawer refresh failed:", err);
  }
}


/***************************************************
 * STRIP PARENT PROPERTY FROM DRAWER ITEMS
 * - Removes ONLY product-cart-item-options blocks
 *   where the first span is literally "parent:"
 * - Keeps phone options (Storage, Condition, Color)
 ***************************************************/
function stripParentProperty() {
  document.querySelectorAll("#Cart-Drawer .product-cart-item-options").forEach(opt => {
    const firstSpan = opt.querySelector("span");
    if (firstSpan && firstSpan.textContent.trim().toLowerCase() === "parent:") {
      opt.remove();
    }
  });
}


/***************************************************
 * REFRESH HEADER CART COUNT (THB THEMES)
 ***************************************************/
async function refreshCartCount() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    const countEls = document.querySelectorAll("span.thb-item-count");

    countEls.forEach(el => {
      el.textContent = cart.item_count;
    });

  } catch (err) {
    console.warn("Failed to refresh cart count", err);
  }
}

/***************************************************
 * RGB
 ***************************************************/

document.addEventListener("DOMContentLoaded", () => {
  let angle = 0;
  let lastTime = performance.now();
  const speed = 90;

  function updateGradient(now) {
    const delta = (now - lastTime) / 1000;
    lastTime = now;

    angle = (angle + speed * delta) % 360;

    document.querySelectorAll(".related_product_block_check").forEach(el => {
      el.style.setProperty("--mm-angle", angle + "deg");
    });

    requestAnimationFrame(updateGradient);
  }

  requestAnimationFrame(updateGradient);
});
